module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_0@3x.453efbfc.png";